import { Location, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockLocation } from 'mocks/graphqlMocks/location';

export function mockedDeleteLocationData(deleteLocation: Location): Pick<Mutation, 'deleteLocation'> {
  return {
    deleteLocation
  };
}

export const mockedDeleteLocationDataForMutation = mockedDeleteLocationData(
  generateMockLocation({ id: 'mockedAddedLocationId' })
);

export const mockedDeleteDeviceGroupDataForMutation = mockedDeleteLocationData(
  generateMockLocation({ id: 'TestGroup2' })
);
